<template>
  <div class="cont">
    <section class="home-section">
      <div class="home-section-top">
        <div>
          <h4 class="home-section-title">{{ $t("Бош саҳифа") }}</h4>
          <p class="home-section-subtitle">
            {{ $t("Навбатлар рўйхати теpasидаги бош саҳифа бўлими") }}
          </p>
        </div>
        <div class="home-section-actions">
          <b-button variant="info" @click="goHome">
            {{ $t("Асосий саҳифа") }}
          </b-button>
        </div>
      </div>
      <div class="home-section-stats">
        <span>{{ $t("Жами навбатлар") }}: {{ items.length }}</span>
      </div>
    </section>
    <section class="queue-section">
      <div class="header">
        <h3 class="text-success">{{ $t("Навбат рўйҳати") }}</h3>
        <div style="display: flex; justify-content: space-between;">
          <b-button
            v-if="
              localUser.role != 'Loborant' && localUser.role != 'Shifokor'
            "
            style="margin-left: 10px;"
            class="qoshishBtn mr-2"
            variant="primary"
            @click="DeleteNAv"
          >
            <span>
              {{ $t("Навбатни тозалаш") }}
            </span>
          </b-button>
          <b-button variant="danger" @click="chiqish()">X</b-button>
        </div>
      </div>
      <div class="queue-table-container">
        <b-table
          striped
          hover
          :items="items"
          :fields="translatedFields"
          :sort-desc.sync="sortDesc"
          :sort-asc.sync="sortAsc"
          :sort-by.sync="sortBy"
          :outlined="outlined"
        >
          <template #cell(№)="data">
            {{ data.index + 1 }}
          </template>
        </b-table>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
export default {
  data() {
    return {
      localUser: JSON.parse(localStorage.getItem("user")),
      items: [],
      fields: [
        "№",
        { key: "patient.fullname", label: "Бемор" },
        { key: "room.name", label: "Хона рақами" },
        { key: "date_time", label: "Вақт" },
        // { key: "status", label: "Status" },
        { key: "number", label: "Навбат рақами" }
      ],
      translatedFields: [],
      sortBy: "number",
      sortDesc: false,
      sortAsc: true,
      outlined: true
    };
  },
  watch: {
    "$i18n.locale": {
      immediate: true,
      handler() {
        this.updateTranslatedFields();
      }
    }
  },
  methods: {
    updateTranslatedFields() {
      this.translatedFields = this.fields.map(field => {
        return {
          ...field,
          label: this.$t(field.label)
        };
      });
    },
    DeleteNAv() {
      axios({
        method: "delete",
        url: "registration/setEmptyQueue"
      }).then(res => {
        if (res) {
        }
      });
    },
    getData() {
      setInterval(() => {
        this.data();
      }, 5000);
    },
    goHome() {
      this.$router.push({ path: "/" });
    },
    data() {
      let s = this;
      axios({
        method: "get",
        url: "/registration/queue"
      }).then(res => {
        for (let key of res.data.data) {
          key.date_time = moment(new Date(key.date_time * 1000)).format(
            "YYYY.MM.DD-HH:mm:ss"
          );
        }
        s.items = res.data.data;
        s.totalRows = s.items.length;
      });
    },
    chiqish() {
      this.$router.go(-1);
    }
  },
  mounted() {
    this.updateTranslatedFields();
    this.data();
    this.getData();
  }
};
</script>
<style scoped>
.header {
  display: flex;
  height: 50px;
  justify-content: space-between;
  align-items: center;
  padding: 0px 20px;
}
.home-section {
  background: #f8f9fa;
  border-radius: 8px;
  margin: 16px 0;
  padding: 18px 20px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}
.home-section-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}
.home-section-title {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
}
.home-section-subtitle {
  margin: 6px 0 0;
  color: #6c757d;
}
.home-section-actions {
  display: flex;
  align-items: center;
}
.home-section-stats {
  margin-top: 14px;
  color: #495057;
  font-weight: 500;
}
.queue-section {
  background: #ffffff;
  border-radius: 8px;
  padding: 18px 20px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}
.queue-table-container {
  margin-top: 16px;
}
</style>
